import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  Grid,
  Input,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import React from 'react';

const CorporateRegistration = () => {
  return (
    <Box>
      <Box component={Paper} p={2} mb={2} fontWeight="bold">
        Add / Update Corporate
      </Box>
      <Box>
        <Card sx={{ maxWidth: 345, margin: '20px auto', boxShadow: 3 }} style={{ height: '49rem', overflow: 'auto' }}>
          {/* <CardHeader title="Corporate Details" /> */}
          <Box component={Paper} p={2} mb={2}>
            Corporate Details
          </Box>
          <CardContent>
            <Grid
              container
              spacing={4}
              alignItems="center"
              style={{ display: 'flex', justifyContent: 'space-between', padding: '15px' }}>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  //   label="Code"
                  label={
                    <>
                      Code <span style={{ color: 'red' }}>*</span>
                    </>
                  }
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
              <Grid item xs={3}>
                <FormControl fullWidth variant="standard" margin="dense" size="small">
                  <InputLabel id="quote-type-label">Parent</InputLabel>
                  <Select
                    labelId="quote-type-label"
                    // value={basicForm.quoteType}
                    // onChange={handleBasicChange('quoteType')}
                    label="Parent">
                    {/* {quoteTypes?.map(item => {
                      return <MenuItem value={item?.value}>{item?.label}</MenuItem>;
                    })} */}
                    <MenuItem value="self">Self</MenuItem>
                    <MenuItem value="other">Other</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  //   label="Corporate Name"
                  label={
                    <>
                      Corporate Name <span style={{ color: 'red' }}>*</span>
                    </>
                  }
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  //   label="Pin No"
                  label={
                    <>
                      Pin No <span style={{ color: 'red' }}>*</span>
                    </>
                  }
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={4}
              alignItems="center"
              style={{ display: 'flex', justifyContent: 'space-between', padding: '15px', marginTop: '-50px' }}>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Phone No"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Alt Phone No"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Fax No"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Alt Fax No"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={4}
              alignItems="center"
              style={{ display: 'flex', justifyContent: 'space-between', padding: '15px', marginTop: '-50px' }}>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Email Id"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Alt Email Id"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  //   label="Address Line 1"
                  label={
                    <>
                      Address Line 1 <span style={{ color: 'red' }}>*</span>
                    </>
                  }
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Address Line 2"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={4}
              alignItems="center"
              style={{ display: 'flex', justifyContent: 'space-between', padding: '15px', marginTop: '-50px' }}>
              <Grid item xs={3}>
                <FormControl fullWidth variant="standard" margin="dense" size="small">
                  <InputLabel id="quote-type-label">
                    Country <span style={{ color: 'red' }}>*</span>
                  </InputLabel>
                  <Select
                    labelId="quote-type-label"
                    // value={basicForm.quoteType}
                    // onChange={handleBasicChange('quoteType')}
                    label="Country">
                    {/* {quoteTypes?.map(item => {
                      return <MenuItem value={item?.value}>{item?.label}</MenuItem>;
                    })} */}
                    <MenuItem value="self">India</MenuItem>
                    <MenuItem value="other">Kenya</MenuItem>
                    <MenuItem value="other">Dubai</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={3}>
                <FormControl fullWidth variant="standard" margin="dense" size="small">
                  <InputLabel id="quote-type-label">
                    County <span style={{ color: 'red' }}>*</span>
                  </InputLabel>
                  <Select
                    labelId="quote-type-label"
                    // value={basicForm.quoteType}
                    // onChange={handleBasicChange('quoteType')}
                    label="County">
                    {/* {quoteTypes?.map(item => {
                      return <MenuItem value={item?.value}>{item?.label}</MenuItem>;
                    })} */}
                    <MenuItem value="self">Bihar</MenuItem>
                    <MenuItem value="other">West Bengal</MenuItem>
                    <MenuItem value="other">Telangana</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={3}>
                <FormControl fullWidth variant="standard" margin="dense" size="small">
                  <InputLabel id="quote-type-label">
                    City <span style={{ color: 'red' }}>*</span>
                  </InputLabel>
                  <Select
                    labelId="quote-type-label"
                    // value={basicForm.quoteType}
                    // onChange={handleBasicChange('quoteType')}
                    label="City">
                    {/* {quoteTypes?.map(item => {
                      return <MenuItem value={item?.value}>{item?.label}</MenuItem>;
                    })} */}
                    <MenuItem value="self">Hajipur</MenuItem>
                    <MenuItem value="other">Patna</MenuItem>
                    <MenuItem value="other">Nalanda</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Postal Code"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={4}
              alignItems="center"
              style={{ display: 'flex', justifyContent: 'space-between', padding: '15px', marginTop: '-50px' }}>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Police Station"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="PO Box"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
              <Grid item xs={3}>
                <InputLabel shrink htmlFor="corporate-logo">
                  Corporate Logo
                </InputLabel>
                <Input id="corporate-logo" type="file" fullWidth disableUnderline />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Corporate Type"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={4}
              alignItems="center"
              style={{ display: 'flex', justifyContent: 'space-between', padding: '15px', marginTop: '-50px' }}>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Industry"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  type="date"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Date of Incorporation"
                  InputLabelProps={{ shrink: true }} // 👈 this keeps label above
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Incorporation Certificate Number"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Bank Account Holder Name"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={4}
              alignItems="center"
              style={{ display: 'flex', justifyContent: 'space-between', padding: '15px', marginTop: '-50px' }}>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Bank Branch Code"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Bank Branch Name"
                  InputLabelProps={{ shrink: true }} // 👈 this keeps label above
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Bank Account Number"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
              <Grid item xs={3}>
                <FormControl fullWidth variant="standard" margin="dense" size="small">
                  <InputLabel id="quote-type-label">Country of Incorporation</InputLabel>
                  <Select
                    labelId="quote-type-label"
                    // value={basicForm.quoteType}
                    // onChange={handleBasicChange('quoteType')}
                    label="Country">
                    {/* {quoteTypes?.map(item => {
                      return <MenuItem value={item?.value}>{item?.label}</MenuItem>;
                    })} */}
                    <MenuItem value="self">India</MenuItem>
                    <MenuItem value="other">Kenya</MenuItem>
                    <MenuItem value="other">Dubai</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={4}
              alignItems="center"
              style={{ display: 'flex', justifyContent: 'space-between', padding: '15px', marginTop: '-50px' }}>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Account Number"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField size="small" margin="dense" fullWidth variant="standard" label="Contact Person Name" />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Contact Person Position"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Contact Person Business Telephone No"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={4}
              alignItems="center"
              style={{ display: 'flex', justifyContent: 'space-between', padding: '15px', marginTop: '-50px' }}>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Contact Person Mobile No"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField size="small" margin="dense" fullWidth variant="standard" label="Contact Person Email Address" />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="AML Risk Category"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Pep Customer"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={4}
              alignItems="center"
              style={{ display: 'flex', justifyContent: 'flex-start', padding: '15px', marginTop: '-50px' }}>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="License Number"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Life Cycle Status"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
            </Grid>
          </CardContent>
          <Box component={Paper} p={2} mb={2}>
            Director Details
          </Box>
          <CardContent>
            <Grid
              container
              spacing={4}
              alignItems="center"
              style={{ display: 'flex', justifyContent: 'flex-start', padding: '15px' }}>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Director Full Name"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Director Id Type"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Director Id Number"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
              <Button variant="outlined">Add</Button>
            </Grid>
          </CardContent>
          <Box component={Paper} p={2} mb={2}>
            Contact Person Details
          </Box>
          <CardContent>
            <Grid
              container
              spacing={4}
              alignItems="center"
              style={{ display: 'flex', justifyContent: 'flex-start', padding: '15px' }}>
              <Grid item xs={3}>
                <FormControl fullWidth variant="standard" margin="dense" size="small">
                  <InputLabel id="quote-type-label">
                    Prefix <span style={{ color: 'red' }}>*</span>
                  </InputLabel>
                  <Select
                    labelId="quote-type-label"
                    required
                    // value={basicForm.quoteType}
                    // onChange={handleBasicChange('quoteType')}
                    label="Country">
                    {/* {quoteTypes?.map(item => {
                      return <MenuItem value={item?.value}>{item?.label}</MenuItem>;
                    })} */}
                    <MenuItem value="self">Mr.</MenuItem>
                    <MenuItem value="other">Mrs.</MenuItem>
                    <MenuItem value="other">Dr.</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  //   label="First Name"
                  label={
                    <>
                      First Name <span style={{ color: 'red' }}>*</span>
                    </>
                  }
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Middle Name"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  //   label="Last Name"
                  label={
                    <>
                      Last Name <span style={{ color: 'red' }}>*</span>
                    </>
                  }
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={4}
              alignItems="center"
              style={{ display: 'flex', justifyContent: 'flex-start', padding: '15px', marginTop: '-50px' }}>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Phone No"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  //   label="Mobile No"
                  label={
                    <>
                      Mobile No <span style={{ color: 'red' }}>*</span>
                    </>
                  }
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  label="Email Id"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>
      <Box>
        <Grid
          container
          spacing={4}
          alignItems="center"
          style={{ display: 'flex', justifyContent: 'flex-end', padding: '15px', gap: '10px' }}>
          <Button variant="outlined">Close</Button>
          <Button variant="outlined">Save</Button>
        </Grid>
      </Box>
    </Box>
  );
};

export default CorporateRegistration;
